class CTRThreeBlends extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        this.init();
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }

    init() {
        this.carouselSelector = this.querySelector('.swiper');
        this.prevButton = this.querySelector('.js-swiper-prev');
        this.nextButton = this.querySelector('.js-swiper-next');
        this.paginationSelector = this.querySelector('.js-swiper-pagination');

        if (this.carouselSelector) {
            this.initCarousel();
        }
    }

    initCarousel() {
        this.swiper = new Swiper(this.carouselSelector, {
            slidesPerView: 1,
            spaceBetween: 16,
            centeredSlides: false,
            pagination: {
                el: this.paginationSelector,
                clickable: true,
            },
            navigation: {
                prevEl: this.prevButton,
                nextEl: this.nextButton,
            },
            breakpoints: {
                750: {
                    slidesPerView: 1.2,
                    spaceBetween: 48,
                },
            },
        });
    }
}

customElements.define('ctr-three-blends', CTRThreeBlends);
